<div class="main" [class]="isLight? 'light':'dark'">
  <div class="gridItem">
    <h3>Distance</h3>
    <h1>{{activity.distance | distance: 'show'}}</h1>
  </div>
  <div class="gridItem">
    <h3>Pace</h3>
    <h1>{{activity.pace | elapsed : 'km'}}</h1>
  </div>
  <div class="gridItem">
    <h3>Time</h3>
    <h1>{{activity.moving_time | elapsed}}</h1>
  </div>
 
<app-polyline-map [mapId]="mapId" [polyline]="activity.map.polyline" [type]="activity.type" [width]="'30vw'" [height]="'30vw'"></app-polyline-map>
</div>